export const DialogActionsSx = {
  padding: 0,
  gap: '16px',
};
